<template>
  <div id="link">
      <div class="title">
          <van-icon name="play" />领取链接：
      </div>
      <div class="box">
          <van-field
            v-model="message"
            disabled
            rows="5"
            autosize
            type="textarea"
            placeholder="复制链接"
            show-word-limit
          />
      </div>
      <div class="btn" @click="copy">复制该链接</div>
      <div class="btn" @click="skipFn">直接跳转</div>
      <div style="font-size: 14px;text-align:left;color:rgb(46 100 255);margin: 0 auto; margin-top: 50px;width: 80%; ">提示：该链接为进入牌桌的入口，可保存至浏览器收藏夹后再添加至桌面快捷方式使用.</div>

      <div style="text-align:center;font-size: 13px;width: 100px; margin: 0 auto; margin-top: 100px;">
         <img src="@/assets/code.jpg" style="width: 100px;height: 100px;margin-bottom: 5px;"/>
         客服联系微信
      </div>
  </div>
</template>

<script>
import { Dialog, Toast } from 'vant';
export default {
  data() {
    return {
        message: '',
    };
  },
  methods: {
      skipFn(){
          if(this.message){
            window.location.href = this.message;
          }
      },
      copy(data){
        let url = this.message;
        //新建一个文本框
        let oInput = document.createElement('input');
        //赋值给文本框
        oInput.value = url;
        document.body.appendChild(oInput);
        // 选择对象;
        oInput.select();
        // 执行浏览器复制命令
        document.execCommand("Copy");
        //复制完成删除掉输入框
        oInput.remove()
        console.log('复制成功')
          this.$notify({
              type: 'success',
              message: '复制成功！'
          }); 
      },
      getLink(){
        let that = this;
        let params = {};
        this.$post('api/divination/user/createInvocationUrl', params)
        .then((res) => {
            this.message = res.data;
        }) 
      },
  },
  created(){
    this.getLink();
  }
};
</script>
<style scope>
#link .btn{
  display:inline-block;
  width: 110px;
  vertical-align: middle;
  background-color: rgba(96,25,133);
  color:#fff;
  text-align:center;
  border-radius: 18px;
  margin-left: 20px;
  font-size: 15px;
}
#link .title{
  font-size: 16px;
  text-align: left;
  padding: 50px 0 0 20px;
  margin-top: 100px;
}
#link .title .van-icon-play{
  color: rgba(96, 25, 133);
}
#link .box{
  border: 1px solid #ccc;
  border-radius: 15px;
  width: 80%;
  margin: 0 auto;
  overflow: hidden;
  margin-top: 20px;
}
</style>

